import { Icon } from '@/modules/Icon';
import { IconType } from '@/shared/types/types';
import { cn } from '@/shared/utils/cn';
import React from 'react';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

export interface ListHeaderProps {
  title: string;
  icon?: IconType;
  onBackClick?: () => void;
  className?: string;
}

export const ListHeader: React.FC<ListHeaderProps> = ({ title, icon, onBackClick, className }) => {
  return (
    <div className={cn('ui-flex ui-items-center ui-gap-8', className)}>
      {onBackClick && (
        <button
          onClick={onBackClick}
          className="ui-flex ui-h-16 ui-w-16 ui-items-center ui-justify-center ui-text-secondary ui-transition-colors hover:ui-text-primary"
          aria-label="Volver"
        >
          <Icon name={icon || faArrowLeft} />
        </button>
      )}
      <h3 className="ui-text-body-sm-regular ui-font-body-sm-bold ui-text-primary">{title}</h3>
    </div>
  );
};
